import React, { Component } from 'react';
import i18n from '../../../plugins/i18n/i18n'
import { actions } from '../../../store/modules';
import { connect } from 'react-redux';
import { Input, Form, Button, notification as Notification } from 'antd';
import { errorMessageNotification } from '../../../helpers/index'
import queryString from "query-string";

class SendEmailConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isSuccess: false,
      email: null,
    }
  }
  componentDidMount() {

    let params = queryString.parse(window.location.search);
    if (params.email) {
      this.setState({ email: params.email })

    } else {
    }
  }

  fetch = (values) => {

    let endpoint = { keyOne: `account/sendemailconfirmationmessage` };

    this.setState({ loading: true })

    this.props.dispatch(
      actions.definitions.addData({
        ...endpoint,
        data: values
      })
    )
      .then((response) => {
        this.setState({ check: response })

        this.setState(
          {
            isSuccess: true,
            loading: false

          },
          () => {
            Notification.success({
              message: "Doğrulama e-postası gönderildi.",
              className: "general-notification",
              placement: "bottomLeft",
              duration: 3,
            });
          })

      }
      )
      .catch(error => {
        this.setState(
          {
            loading: false

          },
          () => {
            Notification.error({
              message: i18n.t(`error`, {
                lng: this.props.currentLanguage,
              }),
              description: errorMessageNotification(error),
              className: "general-notification",
              placement: "bottomLeft",
              duration: 100,
            });
          })
      })
  }


  render() {

    let { loading, email } = this.state;
    
    return (
      <div className="auth-content">

        {
          <h1 className="heading">
            Hesap doğrulama
          </h1>

        }
        {
          email && 
          <div className='form-box'>

            <Form
              layout="vertical"
              onFinish={this.fetch}>

              <Form.Item
                label="E-posta Adresi"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: i18n.t("emailInvalid")
                  },
                  {
                    required: true,
                    message: `${i18n.t("fieldIsRequired", {
                      lng: this.props.currentLanguage,
                    })}`,
                  }
                ]}
                initialValue={email}
                extra="Hesabınızı doğrulamak için e-posta adresinizi yazınız."

              >
                <Input
                  type="email"
                  placeholder="e-posta@alanadi.com" />
              </Form.Item>

              <Form.Item>
                <Button
                  className="width-100"
                  htmlType="submit"
                  type="primary"
                  loading={loading}
                  style={{ marginBottom: 50 }}
                >
                  {
                    i18n.t('Doğrulama E-Postası Gönder', { lng: this.props.currentLanguage })
                  }

                </Button>
              </Form.Item>
            </Form>

          </div>

        }
      </div>
    )
  }
}


const mapStateToProps = ({ auth }) => ({
  ...auth
});
export default connect(mapStateToProps)(SendEmailConfirmation);





// WEBPACK FOOTER //
// ./src/components/Auth/Views/SendEmailConfirmation.js